import { STALE_TIME_RESOURCES } from "@impero-com/common/utils/query_client";

import { useGetUsersUserIdEntitiesSuspense } from "api/generated/users/users";

export function useEntitiesForUserQuery(userId: number) {
    return useGetUsersUserIdEntitiesSuspense(userId, {
        query: {
            select: (response) => response.data,
            refetchOnMount: true,
            refetchOnWindowFocus: true,
            staleTime: STALE_TIME_RESOURCES,
        },
    });
}
